"use client";

import * as Sentry from "@sentry/nextjs";
import { useEffect } from "react";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    try {
      Sentry.captureException(error, {
        tags: { digest: error.digest },
      });
    } catch (sentryError) {
      console.error(JSON.stringify({
        level: "warning",
        message: "Global error boundary: Sentry.captureException failed",
        sentryError: sentryError instanceof Error ? sentryError.message : String(sentryError),
        timestamp: new Date().toISOString(),
      }));
    }
    console.error(JSON.stringify({
      level: "error",
      message: "Global error boundary caught unhandled error",
      errorMessage: error.message,
      digest: error.digest,
      stack: error.stack,
      timestamp: new Date().toISOString(),
    }));
  }, [error]);

  return (
    <html lang="en">
      <body>
        <div className="min-h-screen flex items-center justify-center bg-background">
          <div className="text-center p-8">
            <h1 className="text-2xl font-semibold mb-4">Something went wrong</h1>
            <p className="text-muted-foreground mb-6">
              An unexpected error occurred. Please try again.
            </p>
            {error.digest && (
              <p className="text-xs text-muted-foreground mb-4">
                Error reference: {error.digest}
              </p>
            )}
            <button
              onClick={() => reset()}
              className="px-4 py-2 bg-primary text-primary-foreground rounded-md hover:bg-primary/90"
            >
              Try again
            </button>
          </div>
        </div>
      </body>
    </html>
  );
}
